export const docsOficiaisInitialState = {
  documentosOficiais: [],
  documentoOficial: {},
  documentoApagado: {},
  documentoOficialAdicionado: {},
  lastDocumentosOficiais: [],
};
